import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d461d62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-component p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-col-3" }
const _hoisted_3 = { style: {"font-size":"1rem"} }
const _hoisted_4 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-col-3" }
const _hoisted_7 = { style: {"font-size":"1rem"} }
const _hoisted_8 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_9 = { class: "p-col-3" }
const _hoisted_10 = { style: {"font-size":"1rem"} }
const _hoisted_11 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_12 = { class: "p-col-3" }
const _hoisted_13 = { style: {"font-size":"1rem"} }
const _hoisted_14 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_15 = { class: "p-pr-0 p-col-12 p-formgrid p-grid" }
const _hoisted_16 = { class: "p-col-3" }
const _hoisted_17 = { class: "p-col-6 p-offset-3 p-pr-0" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.trainingKey.description), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.trainingKey.value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainingKey.value.value) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"]),
        (!(_ctx.trainingKey.value.value !== '' && _ctx.trainingKey.value.value !== null))
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t("Squeeze.Training.TrainingKey")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("Squeeze.Training.Indicator")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.indicatorId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.indicatorId) = $event)),
          options: _ctx.allIndicators,
          optionLabel: "description",
          optionValue: "id",
          onChange: _ctx.getAllRegionAnchors
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('Squeeze.Training.Region') + ' ' + _ctx.$t('Squeeze.Training.Anchor')), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.regionAnchorId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.regionAnchorId) = $event)),
          options: _ctx.allRegionAnchors,
          optionLabel: "description",
          optionValue: "id",
          onChange: _ctx.getAllItemFields
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('Squeeze.Training.Region') + ' ' + _ctx.$t('Squeeze.Training.Fields')), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.itemFieldId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemFieldId) = $event)),
          options: _ctx.allItemFields,
          optionLabel: "valuePattern",
          style: {"height":"2.84rem"}
        }, {
          value: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.getItemFieldValueDescription(slotProps.value)), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.getItemFieldDescription(slotProps.option)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Button, {
            label: _ctx.$t('Squeeze.Training.Test'),
            disabled: !_ctx.indicatorId && _ctx.trainingKey.value.value !== '' && _ctx.trainingKey.value.value !== null,
            onClick: _ctx.getTestData
          }, null, 8, ["label", "disabled", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_Button, {
            label: _ctx.$t('Squeeze.Training.ResetTestFilter'),
            disabled: !_ctx.indicatorId && !_ctx.regionAnchorId && !_ctx.itemFieldId,
            onClick: _ctx.resetTestFilter
          }, null, 8, ["label", "disabled", "onClick"])
        ])
      ])
    ]),
    _hoisted_18,
    _createVNode(_component_DataTable, {
      class: "p-component p-shadow-2",
      value: _ctx.testData,
      autoLayout: true,
      rowHover: true,
      loading: _ctx.loading,
      onRowClick: _ctx.onMarkRegion,
      scrollable: true,
      scrollHeight: "flex"
    }, {
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1)
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.Reports.Data') })), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "value",
          header: _ctx.$t('Squeeze.Training.ResultValue')
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "boundingBox.page",
          header: _ctx.$t('Squeeze.Locators.Site')
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "boundingBox.x0",
          header: "x0"
        }),
        _createVNode(_component_Column, {
          field: "boundingBox.y0",
          header: "y0"
        }),
        _createVNode(_component_Column, {
          field: "boundingBox.x1",
          header: "x1"
        }),
        _createVNode(_component_Column, {
          field: "boundingBox.y1",
          header: "y1"
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "onRowClick"])
  ], 64))
}